const INITIAL_STATE = {
  googleSubscriptionOnHoldAlertShown: false,
};

module.exports = function EphemeralMiscallaneaReducer(
  state = INITIAL_STATE,
  action,
) {
  // noinspection JSRedundantSwitchStatement
  switch (action.type) {
    case 'SET_GOOGLE_SUBSCRIPTION_ON_HOLD_ALERT_SHOWN':
      return {
        ...state,
        googleSubscriptionOnHoldAlertShown: action.alertShown || false,
      };
    default:
      return state;
  }
};
